import * as Yup from 'yup';
import { IOfficeHoursWeekRule, TDay } from 'types/e-visits';

export interface IFormValues extends IOfficeHoursWeekRule {
  id?: string;
  validityFrom: boolean;
  validityTo: boolean;
  validFrom: string;
}

/**
 * Sort rule by start time
 * @param rules rules to dort
 * @returns sorted rules copy
 */
function sortRulesByStart(rules: { from: string; to: string }[]) {
  return [...rules].sort((a, b) => (a.from < b.from ? -1 : a.from > b.from ? 1 : 0));
}

export const validationSchema = Yup.object({
  days: Yup.object()
    .shape(
      [...new Array(7).keys()].reduce((acc, k) => {
        acc[k] = Yup.array()
          .of(
            Yup.object().shape({
              from: Yup.date().required(),
              to: Yup.date().required(),
            }),
          )
          .test('overlapping-ranges', 'officeHoursEdit_overlapping_ranges', function test(v) {
            if (v) {
              const events = sortRulesByStart(v as any);
              while (events.length > 0) {
                const e = events.shift();
                while (events.length > 0 && e!.from <= events[0].from && e!.to > events[0].from) {
                  return false;
                }
              }
              return true;
            }
            return true;
          });
        return acc;
      }, {} as any),
    )
    .test('one-range', 'officeHoursEdit_one_range_error', (value) => {
      if (value) {
        for (const key in value) {
          if (Object.prototype.hasOwnProperty.call(value, key)) {
            const element = value[key as unknown as TDay];

            if (element && element.length > 0) {
              return true;
            }
          }
        }
        return false;
      }
      return false;
    })
    .test('one-range', 'officeHoursEdit_one_range_error', (value) => {
      if (value) {
        for (const key in value) {
          if (Object.prototype.hasOwnProperty.call(value, key)) {
            const element = value[key as unknown as TDay];

            if (element && element.length > 0) {
              return true;
            }
          }
        }
        return false;
      }
      return false;
    }),
  validFrom: Yup.date(),
  validTo: Yup.date(),
  expertiseCode: Yup.string().nullable(),
  medicalInstitutionId: Yup.string().nullable(),
  validity: Yup.boolean().test(
    'validity-dates',
    'officeHoursEdit_no_validity_dates',
    function test(value) {
      const validFrom = this.parent.validFrom;
      const validTo = this.parent.validTo;

      if (value && !validFrom && !validTo) {
        return false;
      }

      return true;
    },
  ),
});
